/**
 * 代码生成模式
 */
export const customCodeMode = {
  value: 'custom',
  label: '使用自定义协议生成代码'
};
export const autoCodeMode = {
  value: 'auto',
  label: '智能匹配生成（默认），此模式不支持可视化'
};
export const wujiCodeModel = {
  value: 'wuji',
  label: '使用无极协议生成代码'
};
export const codeGenerateModes = [autoCodeMode, customCodeMode, wujiCodeModel];
export function getCodeGenerateMode(value) {
  const target = codeGenerateModes.find(item => item.value === value);
  return target || customCodeMode; // 如果没有，就走老的逻辑
}
//# sourceMappingURL=codeGenerateModes.js.map
